import * as React from 'react';
import * as classNames from 'classnames';
import { LoadFailure } from '../LoadFailure';
import { LoadingSpinner } from '../LoadingSpinner';

export interface AsyncLoaderProps<T, TError> {
  className?: string;
  dontShowError?: boolean;
  dontShowLoader?: boolean;
  error: boolean;
  errorMessage?: string;
  errorMessageFactory?: (
    errorClasses: string,
    pageUrl: string,
    errorMessage?: string
  ) => JSX.Element;
  loaderFactory?: () => JSX.Element;
  loading: boolean;
  pageUrl: string;
}

export interface AsyncLoaderState<T, TError> {
  /* empty */
}

export class AsyncLoader<T, TError> extends React.Component<
  AsyncLoaderProps<T, TError>,
  AsyncLoaderState<T, TError>
> {
  static defaultLoaderFactory = (): JSX.Element => <LoadingSpinner />;
  static defaultErrorMessageFactory = (
    errorClasses: string,
    pageUrl: string,
    errorMessage?: string
  ): JSX.Element => (
    <LoadFailure
      message={errorMessage}
      className={errorClasses}
      pageUrl={pageUrl}
    />
  );

  constructor(props: AsyncLoaderProps<T, TError>) {
    super(props);

    this.state = {
      loading: false
    };
  }

  render() {
    const {
      children,
      className,
      dontShowError,
      dontShowLoader,
      error,
      errorMessage,
      errorMessageFactory = AsyncLoader.defaultErrorMessageFactory,
      loaderFactory = AsyncLoader.defaultLoaderFactory,
      loading,
      pageUrl
    } = this.props;

    const baseClasses = classNames(className, 'async-loader');

    const loaderClasses = classNames(baseClasses, 'async-loader-loading');

    const errorClasses = classNames(baseClasses, 'async-loader-error');

    const loaderElement = (
      <div className={loaderClasses}>
        {dontShowLoader ? null : loaderFactory()}
      </div>
    );

    const errorMessageElement = dontShowError ? (
      <div className={errorClasses} />
    ) : (
      errorMessageFactory(errorClasses, pageUrl, errorMessage)
    );

    return loading ? loaderElement : error ? errorMessageElement : children;
  }
}

export default AsyncLoader;



// WEBPACK FOOTER //
// ./src/app/components/Common/AsyncLoader/index.tsx